import { useEffect } from 'react';
import { FieldHelperProps, FieldInputProps, FieldMetaProps } from 'formik';
import useCodelists from 'hooks/useCodelists';
import { DeclarationTypes } from 'store/declarations/enums/common/declaration-types';
import FormSelect from '../formSelect/FormSelect';

type Props = {
    fieldProps?: FieldInputProps<any>;
    fieldMeta?: FieldMetaProps<any>;
    fieldHelper?: FieldHelperProps<any>;
    incoterm?: string;
    onChange?: (id: string) => void;
    onClear?: () => void;
};

const IncotermSelect = ({ incoterm, onChange, onClear, fieldProps, fieldHelper, fieldMeta }: Props) => {
    const { aisCodelists, getIrelandCodelists } = useCodelists();

    useEffect(() => {
        getIrelandCodelists(DeclarationTypes.AIS);
    }, [getIrelandCodelists]);

    return (
        <>
            <FormSelect
                placeholder="Select delivery term"
                selectOptions={aisCodelists?.incotermCode}
                value={incoterm}
                onChange={onChange}
                onClear={onClear}
                fieldHelper={fieldHelper}
                fieldProps={fieldProps}
                fieldMeta={fieldMeta}
            />
        </>
    );
};

export default IncotermSelect;
